<template>
  <div class="centre">
    <h1 class="title is-1">Hello am artist</h1>
    <div v-for="art in pictures" :key="art.src">
      <div class="card art">
        <figure class="image is-square">
          <img class="art-image" :src="art.src" :alt="art.text" />
        </figure>
        {{ art.text }}
        <br/>
      </div>
      <div style="height: 5vh"></div>
    </div>

    <div style="display: none">
      <!-- Used to make images load into dist -->
      <img src="./assets/art/knight_blue.png" alt="" />
      <img src="./assets/art/bishop_black.png" alt="" />
      <img src="./assets/art/pawn_black.png" alt="" />
      <img src="./assets/art/rocket.png" alt="" />
      <img src="./assets/art/Normal.png" alt="" />
      <img src="./assets/art/young.png" alt="" />
    </div>
  </div>
</template>


<script>
export default {
  name: "Art",
  data() {
    return {
      pictures: [
        {
          src: "dist/knight_blue.png",
          text: "Chess game dude 1",
        },
        {
          src: "dist/bishop_black.png",
          text: "Chess game dude 2",
        },
        {
          src: "dist/pawn_black.png",
          text: "Chess game dude 3",
        },
        {
          src: "dist/rocket.png",
          text: "Rocket dude",
        },
        {
          src: "dist/Normal.png",
          text: "Space game dude 1",
        },
        {
          src: "dist/young.png",
          text: "Chess game dude 2",
        },
      ],
    };
  },
};
</script>


<style lang="scss">
h1 {
  color: white !important;
}

ul {
  color: rgb(210, 210, 210) !important;
}

.art {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}

.art-image {
  image-rendering: pixelated;
}
</style>


// WEBPACK FOOTER //
// src/Art.vue